// extracted by mini-css-extract-plugin
export var redoItem = "_nr-1";
export var redoTrigger = "_nr-0";